//接頭辞がguiとpmとtwで混合していますが、これに特別な意図はありません。時短です。
const customJa = {
  ja: {
    "gui.extension.tmpose2scratch.name": "TMPose2Scratch",
    "gui.extension.tmpose2scratchblocks.description": "ポーズを学習させよう。",
    "gui.extension.imageclassifier2scratch.name": "ImageClassifier2Scratch",
    "gui.extension.ic2scratchblocks.description": "カメラ画像に写っているものを認識します。結果は英語で返されます。",
    "gui.extension.blockai.name": "BlockAI",
    "gui.extension.blockai.description": "geminiでコーディングのサポートをします。実験的で、間違った情報などを返す場合があります。",
    "gui.extension.newhandpose2scratch.name": "NewHandpose2Scratch",
    "gui.extension.newhandpose2scratchblocks.description": "新しい手の形を認識する拡張機能です。かなり高速で、奥行き(z座標)は検出できません。",
    "gui.extension.handpose2scratch.name": "Handpose2Scratch",
    "gui.extension.handpose2scratchblocks.description": "これは古い手のポーズトラッキングで、少し処理が遅いです。奥行き(z座標)も取得できます。",
    "gui.extension.tm2scratch.name": "TM2Scratch",
    "gui.extension.tm2scratchblocks.description": "画像や音声を学習させよう。",
    "gui.extension.ml2scratch.name": "ML2Scratch",
    "gui.extension.ml2scratch.description": "プロジェクト内でカメラやステージの画像を学習・認識できます。",
    "gui.extension.posenet2scratch.name": "Posenet2Scratch",
    "gui.extension.posenet2scratch.description": "特別なデバイスを使わずに、通常のWebカメラで人間のポーズを迅速かつ正確に検出します",
    "gui.extension.facemesh2scratch.name": "Facemesh2scratch",
    "gui.extension.facemesh2scratch.description": "プロジェクトでフェイストラッキングを活用しましょう!",
    "gui.extension.handpose2scratch2.name": "Handpose2scratch",
    "gui.extension.handpose2scratch2.description": "手の細かい部位の座標を取得・トラッキングできます。",
    "gui.extension.p5js.name": "p5js",
    "gui.extension.p5js.description": "p5.js ライブラリを使用するいくつかのブロック。",
    "gui.extension.music.name": "音楽",
    "gui.extension.music.description": "楽器やドラムを演奏します。",
    "gui.extension.pen.name": "ペン",
    "gui.extension.pen.description": "スプライトで描画します。",
    "gui.extension.animatedtext.name": "アニメーションテキスト",
    "gui.extension.animatedtext.description": "文字に命を吹き込みます。元々、Scratch公式が開発中のものでした。",
    "gui.extension.videosensing.name": "ビデオセンシング",
    "gui.extension.videosensing.description": "カメラで動きを感知します。",
    "gui.extension.text2speech.name": "テキスト読み上げ",
    "gui.extension.text2speech.description": "プロジェクトを話させます。",
    "gui.extension.translate.name": "翻訳",
    "gui.extension.translate.description": "テキストを多くの言語に翻訳します。",
    "gui.extension.looksexpanded.name": "見た目＋",
    "gui.extension.looksexpanded.description": "「見た目」カテゴリのブロックの機能を拡張します。",
    "gui.extension.sensingplus.name": "調べる＋",
    "gui.extension.sensingplus.description": "「調べる」カテゴリのブロックの機能を拡張します。",
    "gui.extension.windowcontrols.name": "ウィンドウを操作",
    "gui.extension.windowcontrols.description": "ウィンドウを動かしたり、大きさや名前を変えたり、全画面にしたり、画面のサイズを調べたりします。",
    "gui.extension.stretch.name": "ストレッチ",
    "gui.extension.stretch.description": "スプライトを横方向または縦方向に拡大・伸縮できます。",
    "gui.extension.makeymakey.name": "Makey Makey",
    "gui.extension.makeymakey.description": "何でもキーに変えられます。",
    "gui.extension.stagecamera.name": "ステージカメラ",
    "gui.extension.stagecamera.description": "ステージ上のどこにでもスクリーンを移動したり、スクリーンの拡大率を設定したりできます。",
    "gui.extension.files.name": "ファイル",
    "gui.extension.files.description": "ファイルの読み取りと作成ができるブロック",
    "gui.extension.zip.name": "ZIP",
    "gui.extension.zip.description": ".sb3、.pmp、.s4s.txtファイルを含むzip形式のファイルを作成および編集します。",
    "gui.extension.penplus.name": "ペン+",
    "gui.extension.penplus.description": "Scratchのデフォルトのペン拡張機能を拡張します。テクスチャや色合いを使用して三角形を描いたり、画像を描画してピクセルを編集したりするためのブロックを追加します。",
    "gui.extension.soundsystems.name": "サウンドシステム",
    "gui.extension.soundsystems.description": "より集中的なオーディオ作業のためのオーディオ グループ化システム。",
    "gui.extension.tunesharkv3.name": "チューン・シャーク V3",
    "gui.extension.tunesharkv3.description": "複雑なサウンドコントロール、複数のオーディオ効果などを備えた高度なオーディオ エンジン。",
    "gui.extension.soundwaves.name": "サウンドウェーブ",
    "gui.extension.soundwaves.description": "音を作ろう！",
    "gui.extension.motionexpansion.name": "動きの拡張",
    "gui.extension.motionexpansion.description": "移動や衝突のための小さなモーション ブロックが増えました。",
    "gui.extension.eventsexpansion.name": "「イベント」の拡張",
    "gui.extension.eventsexpansion.description": "情報の送受信、特定のスプライトの通知、または物事が起こるタイミングをより適切に制御するためのイベントが増えます。",
    "gui.extension.controlsexpansion.name": "「制御」の拡張",
    "gui.extension.controlsexpansion.description": "アニメーション、複雑なシステム、またはよりクリーンな 1 回限りの使用ブロック用の制御ブロックが増えました。",
    "gui.extension.sensingexpansion.name": "「調べる」の拡張",
    "gui.extension.sensingexpansion.description": "特定のユースケースやユーザーのデバイスとの対話のための、より多くの「調べる」ブロック。",
    "gui.extension.operatorsexpansion.name": "「演算」の拡張",
    "gui.extension.operatorsexpansion.description": "NAND、NOR、文字コードから文字への変換、複数行のテキストを行ごとに読み取るなどの演算子。",
    "gui.extension.myblocksplus.name": "定義ブロック+",
    "gui.extension.myblocksplus.description": "カスタム入力、色などを使用して、プライベートまたはグローバルのカスタム ブロックを作成します。",
    "gui.extension.bettercomments.name": "コメントのカスタマイズ",
    "gui.extension.bettercomments.description": "カスタマイズとマークダウンのサポートにより、コメントの見た目を良くします。",
    "gui.extension.json.name": "JSON",
    "gui.extension.json.description": "JSON オブジェクトと配列を処理するためのブロック。",
    "gui.extension.swiftjson.name": "Swift JSON",
    "gui.extension.swiftjson.description": "潜在的に危険ですが、JSONオブジェクトと配列の処理を高速化する拡張機能です。プロジェクトでJSONを頻繁に使用する場合に推奨されます。",
    "gui.extension.particleengine.name": "パーティクルエンジン",
    "gui.extension.particleengine.description": "クローンなしで強力なパーティクルエンジンを作成する",
    "gui.extension.customstyles.name": "カスタムスタイル",
    "gui.extension.customstyles.description": "プロジェクト内の変数モニターとプロンプトの外観をカスタマイズします。",
    "gui.extension.physics.name": "物理エンジン",
    "gui.extension.physics.description": "Griffpatch によって作成された物理処理をとても簡単にするBox2D拡張機能。",
    "gui.extension.tweening.name": "トゥイーン",
    "gui.extension.tweening.description": "さまざまなイージング関数と方向を使用して値をスムーズにアニメーション化します。",
    "gui.extension.tailgating.name": "追従",
    "gui.extension.tailgating.description": "RPG のパーティ メンバーのように、スプライトとクローンを他のスプライトとクローンの後ろをオフセットで追従させます。",
    "gui.extension.tilegrids.name": "タイルグリッド",
    "gui.extension.tilegrids.description": "スプライトをグリッド上に配置します。",
    "gui.extension.canvaseffects.name": "キャンバス効果",
    "gui.extension.canvaseffects.description": "ステージ全体に視覚効果を適用します。",
    "gui.extension.clonesplus.name": "クローン+",
    "gui.extension.clonesplus.description": "Scratchのクローン機能を拡張します。",
    "gui.extension.skins.name": "スキン+",
    "gui.extension.skins.description": "スプライトを他の画像や衣装として表示します。",
    "gui.extension.multipletimers.name": "複数タイマー",
    "gui.extension.multipletimers.description": "個別に制御できるタイマーを作成します。",
    "gui.extension.temporaryvariables.name": "一時変数",
    "gui.extension.temporaryvariables.description": "1つのブロックスタック内でのみ使用する変数を作成します。一度しか使用しない変数で変数リストが乱雑になるのを防ぐのに役立ちます。",
    "gui.extension.turbowarptemporaryvariables.name": "TurboWarp一時変数",
    "gui.extension.turbowarptemporaryvariables.description": "使い捨てのランタイム変数またはスレッド変数を作成します。",
    "gui.extension.runtimemodifications.name": "ランタイム変更",
    "gui.extension.runtimemodifications.description": "ステージやスプライトなどの Scratch オブジェクトを更新するためのブロック。",
    "gui.extension.fontmanager.name": "フォントマネージャー",
    "gui.extension.fontmanager.description": "フォントを管理、作成、削除します。",
    "gui.extension.storage.name": "ストレージ",
    "gui.extension.storage.description": "プロジェクトが閉じられた後でもデータを保存します。基本サーバーストレージも含まれます。",
    "gui.extension.http.name": "HTTP",
    "gui.extension.http.description": "外部 Web サイトとやりとりするための包括的な拡張機能。",
    "gui.extension.cloudlink.name": "クラウドリンク",
    "gui.extension.cloudlink.description": "強力なWebSocket拡張機能。",
    "gui.extension.scripts.name": "スクリプト",
    "gui.extension.scripts.description": "プロジェクトの実行中にブロックを使用してコンパイルされたスクリプトを作成します。",
    "gui.extension.pangapi.name": "Pang API",
    "gui.extension.pangapi.description": "PenguinMod APIから情報を取得します。",
    "gui.extension.3dmath.name": "3D数学",
    "gui.extension.3dmath.description": "独自のスプライトベースの 3D エンジンを作成するためのユーティリティ。",
    "gui.extension.randomutilities.name": "ランダムユーティリティ",
    "gui.extension.randomutilities.description": "シードベースの数値生成、真の数値生成、UUID、ランダム文字列など、ランダム値の生成に関連する多くのブロック。",
    "gui.extension.lzcompress.name": "LZ圧縮",
    "gui.extension.lzcompress.description": "lz-stringを使用してテキストを圧縮および解凍します。",
    "gui.extension.prism.name": "プリズム",
    "gui.extension.prism.description": "特定のユースケースまたは主要な利便性のためのブロック。",
    "gui.extension.vector.name": "ベクトル",
    "gui.extension.vector.description": "X座標とY座標の計算のためのベクトル型。",
    "gui.extension.oddmessages.name": "奇妙なメッセージ",
    "gui.extension.oddmessages.description": "ログ記録と変数の利用。",
    "gui.extension.htmliframeelements.name": "HTML iframe要素",
    "gui.extension.htmliframeelements.description": "HTML コンテンツまたは Web サイトを含むフレームを配置および移動するためのブロック。",
    "gui.extension.colorpicker.name": "カラーピッカー",
    "gui.extension.colorpicker.description": "ユーザーが組み込みのカラーピッカーを使用して色を選択できるようにすることで、独自にカラーピッカーを作成する必要はありません。",
    "gui.extension.colorutilityblocks.name": "色ユーティリティブロック",
    "gui.extension.colorutilityblocks.description": "16 進数、RGB、HSV、10 進数の色やその他の色関連のコンバーター。",
    "gui.extension.allmenus.name": "すべてのメニュー",
    "gui.extension.allmenus.description": "各ブロックのすべてのドロップダウンメニューを抽出します。",
    "gui.extension.labels.name": "ラベル",
    "gui.extension.labels.description": "ラベリングとプレースホルダー。",
    "gui.extension.perlinnoise.name": "パーリンノイズ",
    "gui.extension.perlinnoise.description": "Perlinノイズを生成・使用するためのブロック。地形や雲などの生成に適しています。",
    "gui.extension.gamepad.name": "ゲームパッド",
    "gui.extension.gamepad.description": "ボタンをキーにマッピングするのではなく、ゲームパッドに直接アクセスします。",
    "gui.extension.printing.name": "印刷",
    "gui.extension.printing.description": "テキスト、画像、カスタム HTML をプリンターに印刷するためのダイアログを表示できます。",
    "gui.extension.clippingandblending.name": "クリッピングとブレンディング",
    "gui.extension.clippingandblending.description": "指定された長方形領域の外側をクリッピングし、加法的なカラーブレンドを行います。",
    "gui.extension.pointerlock.name": "ポインターロック",
    "gui.extension.pointerlock.description": "マウスカーソルをステージ上に固定する拡張機能。",
    "gui.extension.mousecursor.name": "マウスカーソル",
    "gui.extension.mousecursor.description": "ステージ上でのマウス カーソルの外観を変更する拡張機能。",
    "gui.extension.scratchauthentication.name": "Scratch認証",
    "gui.extension.scratchauthentication.description": "Scratch認証で実際のScratch ユーザーであることを証明します。",
    "gui.extension.javascript.name": "JavaScript",
    "gui.extension.javascript.description": "JavaScriptで記述された独自のカスタムコードを実行しましょう。",
    "gui.extension.arrays.name": "配列",
    "gui.extension.arrays.description": "多目的配列にデータを効率的に保存します。",
    "gui.extension.targets.name": "ターゲット",
    "gui.extension.targets.description": "スプライトとそのクローンへの直接アクセス。",
    "gui.extension.infinity.name": "無限",
    "gui.extension.infinity.description": "非常に大きな数値を扱える高度な数値タイプです。",
    "gui.extension.color.name": "色",
    "gui.extension.color.description": "色に関わるあらゆるもののためのユーティリティ。",
    //"gui.extension.microbit.name": "micro:bit",
    //"gui.extension.microbit.description": "Connect your projects with the world.",
    //"gui.extension.microbit.connectingMessage": "接続中",
    //"gui.extension.legomindstormsev3.name": "LEGO MINDSTORMS EV3",
    "gui.extension.legomindstormsev3.description": "インタラクティブなロボットなどを構築します。",
    //"gui.extension.legomindstormsev3.connectingMessage": "接続中。EV3のPINが1234に設定されていることを確認してください。",
    //"gui.extension.legoboost.name": "LEGO BOOST",
    //"gui.extension.legoboost.description": "ロボット作品に命を吹き込みます。",
    //"gui.extension.legoboost.connectingMessage": "接続中",
    //"gui.extension.legowedo2.name": "LEGO Education WeDo 2.0",
    //"gui.extension.legowedo2.description": "モーターとセンサーを使って組み立てます。",
    "pm.extraLibraryExtensions.name":"Penguinmodの拡張機能",
    "pm.extraLibraryExtensions.description": "Penguinmodユーザーが投稿した拡張機能をいくつかご覧ください。新しいタブで開きます。",
    "tw.extensionGallery.name": "TurboWarpの拡張機能ギャラリー",
    "tw.extensionGallery.description": "ここでは多くの TurboWarp 拡張機能をリストしていますが、extensions.turbowarp.org でさらに多くの拡張機能を見つけることができます。",
    "gui.extension.sharkpoolExt.name": "シャークプールの拡張機能",
    "gui.extension.sharkpoolextensioncollection.description": "SharkPool によって作成された多数の拡張機能。このメニューが開いているときに拡張機能をクリックすると、プロジェクトに追加されます。CORS制限のため、別のホストですが機能は同じで自動更新されます。",
    "gui.extension.extforge.name": "ExtForge",
    "gui.extension.extforge.description": "ブロックベースの UI を使用して拡張機能を作成します。",
    "gui.extension.customextension.name": "カスタム拡張機能",
    "gui.extension.customextension.description": "好きな拡張機能を読み込むことができます。",
    "gui.menuBar.LanguageSelector": "言語選択",
    "pm.menuBar.gameplaySettings": "高度な設定",
    "google.drive.saveButton": "Googleドライブに保存",
    "pm.backToHomeButton": "ホームに戻る",
    "gui.gui.variablesTab": "変数",
    "gui.controls.pause": "一時停止",
    "gui.directionPicker.rotationStyles.lookAt": "注視",
    "gui.directionPicker.rotationStyles.upDown": "上下",
    "pm.guiDefaultTitle": "無題のプロジェクト",
    "gui.menuBar.pmshare": "共有",
    "pm.embed.connectFuture": "すべてのウェブサイトでこの設定を保持する",
    "pm.customExtensionModal.unsandboxedWarning2": "サンドボックス化されていない拡張機能は、プロジェクトの破損、設定の削除、パスワードのフィッシングなど、様々な悪質な行為を引き起こす可能性があります。 {APP_NAME} の開発者は、結果として生じる問題について一切責任を負いません。",
    "pm.customExtensionModal.corsProblem": "お使いのブラウザでは、エディターが拡張機能のコードにアクセスできない可能性があります。問題が発生している場合は、ファイルまたはテキストから読み込みをお試しください。",
    "pm.customExtensionModal.addToLibrary": "拡張機能を拡張機能リストに追加する",
    "pm.customExtensionModal.libraryName": "拡張機能の名前",
    "pm.customExtensionModal.libraryDescription": "拡張機能についての説明",
    "pm.customExtensionModal.libraryImage": "拡張機能のバナー画像(大きく拡張機能名の上に表示されます。)",
    "pm.customExtensionModal.libraryOnlyYours1": "この拡張機能はあなたの拡張機能リストにのみ表示されます。",
    "pm.customExtensionModal.libraryOnlyYours2": "他の人に見られることはありません。",
    "pm.extensionLibrary.customLibraryExtensionUnsandboxed": "サンドボックス化されていないカスタム拡張機能",
    "pm.extensionLibrary.customLibraryExtensionSandboxed": "サンドボックス化されたカスタム拡張機能",
    "pm.extensionLibrary.customLibraryExtensionWebsite": "URLから追加",
    "pm.extensionLibrary.customLibraryExtensionTextOrFile": "テキストまたはファイルから追加",
    "pm.tooLarge": "⚠ファイルサイズが大きいため、アップロードできない可能性があります。",
    "pm.formatAlert": "⚠このサウンドを編集すると、はるかに大きな WAV 形式のサウンドに不可逆的に変換されます。",
    "pm.oggSafariAlert": "⚠iOS および macOS のユーザーは、OGG サウンドを聞くためにブラウザまたはデバイスを更新する必要があります。",
    "pm.menuBar.moreSettings": "高度な設定",
    "pm.terms": "利用規約",
    "pm.guiDefaultTitle": "エディター",
    "pm.customExtensionModal.rememberChoice": "プロジェクトのすべての拡張機能にこの操作を実行する",
    "gui.libraryTags.all": "すべて",
    "gui.libraryTags.animals": "動物",
    "gui.libraryTags.dance": "ダンス",
    "gui.libraryTags.effects": "エフェクト",
    "gui.libraryTags.fantasy": "ファンタジー",
    "gui.libraryTags.fashion": "ファッション",
    "gui.libraryTags.food": "食べ物",
    "gui.libraryTags.indoors": "屋内",
    "gui.libraryTags.loops": "ループ",
    "gui.libraryTags.themes": "テーマ",
    "gui.libraryTags.music": "音楽",
    "gui.libraryTags.notes": "音符",
    "gui.libraryTags.outdoors": "屋外",
    "gui.libraryTags.patterns": "パターン",
    "gui.libraryTags.people": "人々",
    "gui.libraryTags.percussion": "打楽器",
    "gui.libraryTags.space": "宇宙",
    "gui.libraryTags.sports": "スポーツ",
    "gui.libraryTags.underwater": "水中",
    "gui.libraryTags.voice": "声",
    "gui.libraryTags.wacky": "おもしろ",
    "gui.libraryTags.animation": "アニメーション",
    "gui.libraryTags.art": "アート",
    "gui.libraryTags.games": "ゲーム",
    "gui.libraryTags.stories": "ストーリー",
    "gui.libraryTags.letters": "文字",
    "gui.libraryTags.swords": "剣",
    "gui.libraryTags.guns": "銃",
    "gui.libraryTags.penguinmod": "PenguinMod",
    "gui.libraryTags.scratch": "Scratch",
    "gui.libraryTags.turbowarp": "TurboWarp",
    "gui.libraryTags.programminglanguage": "プログラミング言語",
    "gui.libraryTags.categoryexpansion": "カテゴリ拡張",
    "gui.libraryTags.ui": "メニュー",
    "gui.libraryTags.footsteps": "足音",
    "gui.libraryTags.custom": "カスタム",
    "gui.libraryTags.customextension": "カスタム拡張機能を読み込む",
    "gui.libraryTags.hardware": "ハードウェア",
    "gui.libraryTags.library": "コレクション",
    "gui.libraryTags.extcreate": "拡張機能作成ツール",
    "gui.libraryTags.datamgmt": "データ管理",
    "gui.libraryTags.graphics": "グラフィックス",
    "gui.libraryTags.noisemaker": "音",
    "gui.libraryTags.metal": "金属音",
    "gui.libraryTags.monster": "モンスター",
    "gui.libraryTags.math": "数学",
    "gui.library.filterPlaceholder": "検索",
    "gui.library.allTag": "すべて",
    "tw.variablesTab.search": "検索",
    "tw.variablesTab.sprite": "このスプライトの変数",
    "tw.variablesTab.global": "すべてのスプライトの変数",
    "tw.variablesTab.showLarge": "非常に大きな値を表示するにはクリックしてください",
    "pm.fonts.system2": "フォントをダウンロードする必要はありませんが、すべてのユーザーに対して正しく表示されるとは限りません。",
    "pm.fonts.custom2": "フォント管理モーダルの一部です。ローカルファイルからフォントを追加するオプションの下に表示されます。{formats}は、'.ttf, .otf'のようなカンマ区切りのファイル形式リストに置き換えられます。",
    "pm.settingsModal.gameplay": "おすすめ",
    "pm.settingsModal.optimizations": "最適化",
    "pm.settingsModal.screenResolution": "スクリーンサイズ",
    "pm.settingsModal.unsupported": "サポート終了",
    "pm.settingsModal.unsupportedWarning": "ここにある設定はサポート対象外であり、いつでも機能しなくなる可能性があります。これらの設定は、より良い方法があるか、他の拡張機能と併用すると頻繁に機能しなくなるため、ここに記載されています。",
    "pm.settingsModal.title": "高度な設定",
    "pm.settingsModal.oobRendering": "画面外レンダリングを無効にする",
    "pm.settingsModal.oobRenderingHelp": "有効にすると、画面外にあるすべてのスプライトはレンダリングされません。",
    "pm.settingsModal.dangerousOptimizations": "危険な最適化を有効にする",
    "pm.settingsModal.dangerousOptimizationsHelp": "特定の数値を事前計算し、特定の操作に高速な手法を使用します。ただし、特定の数値入力欄に特殊テキストを入力するといった小さな機能が失われます。すべてのプロジェクトがこの設定に対応しているわけではありません。",
    "pm.settingsModal.stageSize": "ステージの大きさ",
    "gui.defaultProject.variable": "変数",
    "pm.menuBar.loadFromFolder": "フォルダから読み込む",
    "pm.menuBar.exportToFolder": "フォルダに保存",
    "pm.confirmBuggyUnstableExtension": "この拡張機能は実際のプロジェクトには推奨されません。不安定になり、後でプロジェクトに問題を引き起こす可能性があります。有効にしてもよろしいですか？",
    "gui.extensions": "拡張機能",
    "gui.library.filters": "フィルター",
    "gui.library.actions": "",
    "paint.paintEditor.more": "その他",
    "gui.extension.types": "タイプ",
    "gui.extension.general": "一般",
    "gui.extension.objects": "物",
    "gui.extension.materials": "金属",
    "gui.soundEditor.modify": "修正",
    "gui.soundEditor.lowpass": "高音除去",
    "gui.soundEditor.highpass": "低音除去",
    "gui.soundEditor.format": "フォーマット",
    "gui.gui.soundsTab": "音",
    "gui.lists": "リスト",
    "pm.directionPicker.rotationStyles.lookAt": "左右に向く",
    "pm.directionPicker.rotationStyles.upDown": "上下のみ",
    "pm.gui.variablesTab": "変数",
    "pm.controls.pause": "一時停止"
  }
};

export default customJa;
